export default __webpack_public_path__ + "static/media/print-stars.8b583456.png";